<template>
  <q-dialog
    v-model="shown"
    :maximized="$q.screen.lt.md"
  >
    <q-card>
      <q-card-section class="q-mr-lg">
        <stripe-session-dispute
          type="payment-disputes"
          :payment="payment"
          :is-active="!$_.isNil(payment)"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

import StripeSessionDispute from 'src/modules/admin/site-stripe-configuration/components/StripeSessionDispute'

export default {
  name: 'DisputeDialog',
  configuration: ['currentCircuit'],
  components: {
    StripeSessionDispute
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    }
  },
  emits: ['closed', 'update:model-value'],
  data () {
    return {
      shown: false,
      payment: null,
      summaryOnly: false,
      siteName: null,
      key: 0
    }
  },
  computed: {
    allowDispute () {
      const status = this.dispute.status
      return (status === 'warning_needs_response' || status === 'needs_response') && this.dispute.submissionCount === 0
    },
    differentSiteWarning () {
      return `This dispute was created on a different site (${this.siteName}).  Please change sites to view or manage it.`
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
      if (this.shown) {
        this.$trackPage(this, { orderId: this.id })
      }
    }
  },
  methods: {
    show (payment, summaryOnly = false, siteName = null) {
      this.payment = payment
      this.shown = true
      this.summaryOnly = summaryOnly
      this.siteName = siteName
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
